import { Root } from 'components/Root';
import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';

import { RequireTranslations } from '@project44/translations-utils';

import { translations } from '../l10n/config';
import { UI_TRANSLATIONS_NAMESPACE } from './constants';

export default function App() {
  return (
    <RequireTranslations
      namespace={UI_TRANSLATIONS_NAMESPACE}
      translations={translations}
    >
      <Router>
        <Root />
      </Router>
    </RequireTranslations>
  );
}
